import ThemeIcon from "../ThemeIcon/ThemeIcon";
import "./Service.scss";

const Service = ({ serviceList }) => {
  const { name, description, image, image_url, icon } = serviceList;
  const serviceImage = image_url || image;

  return (
    <div className="col-lg-3 col-md-4 col-sm-6">
      <div className="service-box">
        <div className="service-icon">
          <div className="icon-area">
            {serviceImage ? (
              <div className="image-container">
                <img
                  src={serviceImage}
                  alt={name}
                  className="service-image"
                  onError={(e) => {
                    // Fallback if image fails to load
                    e.target.style.display = "none";
                    // You could show the ThemeIcon as fallback
                    // Or show a default image
                  }}
                />
              </div>
            ) : (
              <ThemeIcon icon={icon} />
            )}
          </div>
        </div>
        <div className="service-text">
          <h3>{name}</h3>
          <p>{description}</p>
        </div>
      </div>
    </div>
  );
};

export default Service;
